import { memo } from 'react';

import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { LocationsFilterCard } from '~/components/Filters/LocationsFilter/LocationsFilterCard';

export const PrivateLocationsFilterCard = memo((props: BaseFilterCardProps) => <LocationsFilterCard {...props} />);

PrivateLocationsFilterCard.displayName = 'PrivateLocationsFilterCard';
